import {
  Box,
  Skeleton,
  Table,
  Thead,
  Tr,
  Th,
  Text,
  Tbody,
  useToast,
} from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import * as _ from 'lodash';
import React from 'react';

import { SlackInstallationRow } from './SlackInstallationRow';
import { SlackInstallationGQLType } from '../../../../../types/dashboard-core-gqlTypes.generated.d';
import { colors } from '~/packages/common-frontend/colors';
import {
  errorToastConfig,
  errorToastId,
} from '~/packages/common-frontend/constants';

export const SlackInstallationsContainer = ({
  slackInstallations,
  isLoading,
  organizationId,
}: {
  slackInstallations: SlackInstallationGQLType[];
  isLoading: boolean;
  organizationId: string;
}) => {
  const toast = useToast();

  if (_.isEmpty(slackInstallations)) {
    return (
      <Text>
        You do not have any active Finley Slack integrations. You can add one by
        clicking &apos;Add to Slack&apos; above.
      </Text>
    );
  }

  if (isLoading) {
    return <Skeleton height="100px" />;
  }

  return (
    <Box>
      <Table variant="simple" size="md" width="65%">
        <Thead
          background={colors.tableHeader}
          borderBottom="1px solid lightgrey"
          padding="8px 0"
        >
          <Tr>
            <Th width="30%">Workspace</Th>
            <Th width="35%">Channel</Th>
            <Th width="30%">Updated</Th>
            <Th width="5%" />
          </Tr>
        </Thead>

        <Tbody>
          {_.map(slackInstallations, (slackInstallation) => {
            return (
              <Sentry.ErrorBoundary
                key={`key-${Math.random()}`}
                onError={() => {
                  if (!toast.isActive(errorToastId)) {
                    errorToastConfig.title = `Error in showing slack installation ${slackInstallation.id}: ${slackInstallation.incomingWebhookChannelName}`;
                    toast(errorToastConfig);
                  }
                }}
              >
                <SlackInstallationRow
                  slackInstallation={slackInstallation}
                  organizationId={organizationId}
                />
              </Sentry.ErrorBoundary>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};
